module.exports = __webpack_public_path__ + "static/media/ow.8d5e6402.jpg";